export default __webpack_public_path__ + "static/media/alertSuspense.a659bf57.svg";